// @flow
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import Actions from '../../actions/Creators';
import {
    Layout,
    DatePicker,
    ToggleButton,
    Loader,
    Button,
    EmptyResults,
    Pagination,
    SearchString,
} from '../../components/common/';
import I18n from '../../i18n/I18n';
import Helper from '../../helper/Helper';
import InvoiceList from '../../components/statement/InvoiceList';
import CreditNoteList from '../../components/statement/CreditNoteList';
import PaymentList from '../../components/statement/PaymentList';
import { DetailHeader, PaymentDetails } from '../../components/statement/index';
import styles from './Statements.scss';

class Statements extends React.Component {
    constructor() {
        super();

        this.state = {
            currentPage: 1,
            itemPerPage: 20,
            fromDate: '',
            toDate: '',
            paidAt: '',
            statementsType: 1,
            invoiceType: 1,
            search: '',
            docType: 1,
            scrollPage: 1,
            scrollLimit: 20,
        };
        this.onBack = this.onBack.bind(this);
        this.toggleStatements = this.toggleStatements.bind(this);
        this.toggleInvoice = this.toggleInvoice.bind(this);
        this.getFinanceViewData = this.getFinanceViewData.bind(this);
        this.exportCreditNote = this.exportCreditNote.bind(this);
        this.exportInvoice = this.exportInvoice.bind(this);
        this.exportStatements = this.exportStatements.bind(this);
        this.selectedFromDate = this.selectedFromDate.bind(this);
        this.selectedToDate = this.selectedToDate.bind(this);
        this.selectedPaidAt = this.selectedPaidAt.bind(this);
        this.clearPaidAt = this.clearPaidAt.bind(this);
        this.clearDate = this.clearDate.bind(this);
    }

    componentDidMount() {
        if (this.props.user && this.props.seller) {
            if (this.props.match.params.statementNr) {
                if (this.state.docType === 1)
                    this.getPaymentDetails(this.props.match.params.statementNr);
                else this.getDisputesData(this.props.match.params.statementNr);
            } else
                this.getInvoicesData(
                    this.state.itemPerPage,
                    this.state.currentPage,
                );
        }
        if (this.props.location && this.props.location.search) {
            this.getParams(this.props.location.search);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.match !== nextProps.match ||
            this.props.seller !== nextProps.seller
        ) {
            if (
                nextProps.location &&
                this.props.location &&
                nextProps.location !== this.props.location &&
                nextProps.location.search
            ) {
                this.getParams(nextProps.location.search);
            } else {
                if (nextProps.match.params.statementNr) {
                    if (this.state.docType === 1)
                        this.getPaymentDetails(
                            nextProps.match.params.statementNr,
                        );
                    else
                        this.getDisputesData(
                            nextProps.match.params.statementNr,
                        );
                } else {
                    this.toggleStatements(this.state.statementsType);
                }
            }
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.state.scrollPage === prevState.scrollPage + 1) {
            this.setState({
                change: true,
            });
        }
        if (this.state.change && this.props.match.params.statementNr) {
            if (this.state.docType === 1)
                this.getPaymentDetails(this.props.match.params.statementNr);
            else this.getDisputesData(this.props.match.params.statementNr);
        }
    };

    toggleStatements = statementsType => {
        if (statementsType === 2) {
            this.getCreditNotesData(
                this.state.itemPerPage,
                1,
                this.state.fromDate,
                this.state.toDate,
                this.state.search,
            );
        } else if (statementsType === 3) {
            this.getPaymentsData(
                this.state.itemPerPage,
                1,
                this.state.fromDate,
                this.state.toDate,
                this.state.search,
            );
        } else {
            this.getInvoicesData(
                this.state.itemPerPage,
                1,
                this.state.fromDate,
                this.state.toDate,
                this.state.search,
            );
        }
        this.setState({
            statementsType,
            currentPage: 1,
            fromDate: '',
            toDate: '',
            paidAt: '',
        });
    };

    loadFunc = () => {
        const { statements } = this.props;

        const noOfPages =
            statements &&
            statements.payments &&
            statements.payments &&
            statements.payments.no_of_pages;

        if (noOfPages > this.state.scrollPage) {
            this.setState({
                scrollPage: this.state.scrollPage + 1,
            });
        }
    };

    toggleInvoice(invoiceType) {
        if (invoiceType === 2) {
            this.getInvoicesNoonData(this.state.itemPerPage, 1);
        } else {
            this.getInvoicesData(this.state.itemPerPage, 1);
        }
        this.setState({
            invoiceType,
            currentPage: 1,
            fromDate: '',
            toDate: '',
            paidAt: '',
        });
    }

    // Toggle function for tabs for payment detail page
    toggleDoc = docType => {
        if (docType === 1) {
            this.getPaymentDetails(this.props.match.params.statementNr);
        } else {
            this.getDisputesData(this.props.match.params.statementNr);
        }
        this.setState({
            docType,
            scrollPage: 1,
        });
    };

    getInvoicesData(limits, page, fromDate, toDate, search) {
        let query = `limits=${limits}&page=${page}`;
        query =
            fromDate && toDate
                ? `${query}&from_date=${fromDate}&to_date=${toDate}`
                : query;
        query = search ? `${query}&search=${search}` : query;

        this.props.dispatch(Actions.getInvoices(query));
    }

    getInvoicesNoonData(limits, page, fromDate, toDate, search) {
        let query = `limits=${limits}&page=${page}`;
        query =
            fromDate && toDate
                ? `${query}&from_date=${fromDate}&to_date=${toDate}`
                : query;
        query = search ? `${query}&search=${search}` : query;

        this.props.dispatch(Actions.getInvoicesNoon(query));
    }

    getPaymentsData(limits, page, fromDate, toDate, search) {
        let query = `limits=${limits}&page=${page}`;
        query =
            fromDate && toDate
                ? `${query}&from_date=${fromDate}&to_date=${toDate}`
                : query;
        query = search ? `${query}&search=${search}` : query;
        this.props.dispatch(Actions.getPayments(query));
    }
    getCreditNotesData(limits, page, fromDate, toDate, search) {
        let query = `limits=${limits}&page=${page}`;
        query =
            fromDate && toDate
                ? `${query}&from_date=${fromDate}&to_date=${toDate}`
                : query;
        query = search ? `${query}&search=${search}` : query;
        this.props.dispatch(Actions.getCreditNotes(query));
    }

    getPaymentDetails(statementNr) {
        const { scrollPage, scrollLimit, change } = this.state;
        let query = statementNr ? `statement_nr=${statementNr}` : '';
        query = `${query}&limits=${scrollLimit}&page=${scrollPage}`;
        this.props.dispatch(Actions.getPaymentDetails(query));
        const newState = {};
        newState.statementsType = 3;
        newState.change = false;
        this.setState(newState);
    }

    getDisputesData = statementNr => {
        const query = statementNr
            ? `statement_nr=${statementNr}&type=documents`
            : '';
        this.props.dispatch(Actions.getPaymentDetails(query));
    };

    rangeSubmit(statementsType) {
        var newState = {};
        newState['currentPage'] = 1;
        this.setState(newState);
        switch (statementsType) {
            case 1:
                if (this.state.invoiceType === 2) {
                    this.getInvoicesNoonData(
                        this.state.itemPerPage,
                        1,
                        this.state.fromDate,
                        this.state.toDate,
                        this.state.search,
                    );
                } else {
                    this.getInvoicesData(
                        this.state.itemPerPage,
                        1,
                        this.state.fromDate,
                        this.state.toDate,
                        this.state.search,
                    );
                }
                break;
            case 2:
                this.getCreditNotesData(
                    this.state.itemPerPage,
                    1,
                    this.state.fromDate,
                    this.state.toDate,
                    this.state.search,
                );
                break;
            case 3:
                this.getPaymentsData(
                    this.state.itemPerPage,
                    1,
                    this.state.fromDate,
                    this.state.toDate,
                    this.state.search,
                );
                break;

            default:
                this.getInvoicesData(
                    this.state.itemPerPage,
                    1,
                    this.state.fromDate,
                    this.state.toDate,
                    this.state.search,
                );
                break;
        }
    }

    getFinanceViewData(itemId) {
        const query = `itemId=${itemId}`;
        this.props.dispatch(Actions.getFinanceView(query));
        this.props.dispatch(Actions.getOrderView(query));
    }

    exportInvoice(invoiceNr) {
        let query = `invoice_nr=${invoiceNr}`;
        query = this.state.invoiceType === 2 ? `${query}&type=noon` : query;
        this.props.dispatch(Actions.exportInvoice(query));
    }

    exportStatements(paidAt) {
        const query = `statement_nr=${paidAt}`;
        this.props.dispatch(Actions.exportStatements(query));
    }

    exportCreditNote(creditNoteNr) {
        const query = `creditnote_nr=${creditNoteNr}`;
        this.props.dispatch(Actions.exportCreditNote(query));
    }

    selectedFromDate(date) {
        const formatted = moment(date).format();

        let toDate = this.state.toDate;

        if (moment(toDate).isBefore(moment(formatted))) {
            toDate = '';
        }

        var newState = {};
        newState['fromDate'] = formatted;
        newState['toDate'] = toDate;
        this.setState(newState);
    }

    selectedPaidAt(date) {
        const formatted = moment(date).format();

        var newState = {};
        newState['paidAt'] = formatted;
        this.setState(newState);
    }

    clearPaidAt() {
        this.getPaymentsData(this.state.itemPerPage, 1);
        this.setState({
            currentPage: 1,
            paidAt: '',
            fromDate: '',
            toDate: '',
        });
    }

    clearDate() {
        this.state.statementsType === 1
            ? this.toggleInvoice(this.state.invoiceType)
            : this.toggleStatements(this.state.statementsType);
    }

    selectedToDate(date) {
        const formatted = moment(date).format();

        var newState = {};
        newState['toDate'] = formatted;
        this.setState(newState);
    }

    onPageChange = page => {
        var newState = {};
        newState['currentPage'] = page.selected + 1;
        this.setState(newState);
        if (this.state.statementsType === 2) {
            this.getCreditNotesData(
                this.state.itemPerPage,
                page.selected + 1,
                this.state.fromDate,
                this.state.toDate,
            );
        } else if (this.state.statementsType === 3) {
            this.getPaymentsData(
                this.state.itemPerPage,
                page.selected + 1,
                this.state.fromDate,
                this.state.toDate,
            );
        } else {
            if (this.state.invoiceType === 2) {
                this.getInvoicesNoonData(
                    this.state.itemPerPage,
                    page.selected + 1,
                    this.state.fromDate,
                    this.state.toDate,
                );
            } else {
                this.getInvoicesData(
                    this.state.itemPerPage,
                    page.selected + 1,
                    this.state.fromDate,
                    this.state.toDate,
                );
            }
        }
    };

    getParams = searchString => {
        const params = URLSearchParams ? new URLSearchParams(searchString) : '';
        const invoiceNr = params && params.get('invoice_nr');
        const newState = {};

        if (invoiceNr) {
            this.onInvoiceSearch(invoiceNr);
            newState.statementsType = 1;
            newState.search = invoiceNr;
            this.setPageUrl();
        }

        this.setState(newState);
    };

    setPageUrl = () => {
        this.props.history.replace(`/${Helper.getLocale()}/statements`);
    };

    onBack() {
        this.props.history.push(`/${Helper.getLocale()}/statements/`);
        // this.getPaymentsData(
        //   this.state.itemPerPage,
        //   this.state.currentPage,
        //   this.state.fromDate,
        //   this.state.toDate,
        //   this.state.search
        // );
        this.setState({
            statementsType: 3,
        });
    }

    onPaymentSearch = search => {
        if (this.props.match.params.offerCode) {
            this.props.history.push(`/${Helper.getLocale()}/products/`);
        }
        this.getPaymentsData(
            this.state.itemPerPage,
            1,
            this.state.fromDate,
            this.state.toDate,
            search,
        );
        var newState = {};
        newState['currentPage'] = 1;
        newState['search'] = search;
        this.setState(newState);
    };

    onInvoiceSearch = search => {
        if (this.state.invoiceType === 2) {
            this.getInvoicesNoonData(
                this.state.itemPerPage,
                1,
                this.state.fromDate,
                this.state.toDate,
                search,
            );
        } else {
            this.getInvoicesData(
                this.state.itemPerPage,
                1,
                this.state.fromDate,
                this.state.toDate,
                search,
            );
        }
        var newState = {};
        newState['currentPage'] = 1;
        newState['search'] = search;
        this.setState(newState);
    };

    onCreditNoteSearch = search => {
        this.getCreditNotesData(
            this.state.itemPerPage,
            1,
            this.state.fromDate,
            this.state.toDate,
            search,
        );
        var newState = {};
        newState['currentPage'] = 1;
        newState['search'] = search;
        this.setState(newState);
    };

    render() {
        const statements = this.props.statements;
        const { seller, user } = this.props;
        const { docType, scrollPage, scrollLimit } = this.state;
        const currencyCode = seller ? seller.currency_code : 'AED';
        const statementNr = this.props.match.params.statementNr;
        const minimumDate = moment(this.state.fromDate || '');
        const maximumDate = moment(this.state.toDate || '');
        const minimumPaidAtDate = moment().subtract(1, 'year');
        const maxDate = moment();
        const onSearch = !statementNr
            ? this.state.statementsType === 2
                ? this.onCreditNoteSearch
                : this.state.statementsType === 3
                ? this.onPaymentSearch
                : this.onInvoiceSearch
            : null;
        const searchLabel = !statementNr
            ? this.state.statementsType === 1
                ? 'statement.invoice-search'
                : 'statement.payment-search'
            : '';
        const noOfPages =
            statements &&
            statements.payments &&
            statements.payments &&
            statements.payments.no_of_pages;

        const showNoLoading = this.state.scrollPage >= noOfPages;

        return (
            <Layout
                currentIndex={4}
                title={'statement.title'}
                onSearch={onSearch}
                searchLabel={searchLabel}
                search={this.state.search}
            >
                {statementNr ? (
                    <div className={styles.statementCtr}>
                        {/* payment details header starts */}
                        <div className={styles.headerWrapper}>
                            {statements &&
                            statements.payments &&
                            statements.payments.statement ? (
                                <DetailHeader
                                    statementNr={
                                        statements.payments.statement.refNo
                                    }
                                    paidAt={
                                        statements.payments.statement.paid_at
                                    }
                                    paymentRef={
                                        statements.payments.statement
                                            .payment_reference
                                    }
                                    total={
                                        statements.payments.statement
                                            .amount_debit
                                    }
                                    currencyCode={
                                        statements.payments.statement.currency
                                    }
                                    lang={this.props.lang}
                                    onBack={this.onBack}
                                />
                            ) : (
                                ''
                            )}
                        </div>
                        {/* payment details header Ends */}

                        <div className={styles.toggleWrapper}>
                            <ToggleButton
                                toggleBtn={this.toggleDoc}
                                toggleItems={[
                                    I18n.getText('statement.item-tab'),
                                    I18n.getText('statement.document-tab'),
                                ]}
                                selected={this.state.docType}
                            />
                        </div>
                        {this.props.isPaymentsLoading &&
                        this.state.scrollPage === 1 ? (
                            <div>
                                <Loader />
                            </div>
                        ) : (
                            <div>
                                {statements &&
                                statements.payments &&
                                statements.payments.statement &&
                                statements.payments.statement.items ? (
                                    <PaymentDetails
                                        data={
                                            statements.payments.statement.items
                                        }
                                        currencyCode={
                                            statements.payments.statement
                                                .currency
                                        }
                                        history={this.props.history}
                                        total={
                                            statements.payments.statement
                                                .amount_debit
                                        }
                                        totalCredit={
                                            statements.payments.statement
                                                .total_credit
                                        }
                                        paidAt={
                                            statements.payments.statement
                                                .paid_at
                                        }
                                        paymentRef={
                                            statements.payments.statement
                                                .payment_reference
                                        }
                                        deductions={
                                            statements.payments.statement
                                                .total_debit
                                        }
                                        statementNr={
                                            statements.payments.statement.refNo
                                        }
                                        onBack={this.onBack}
                                        lang={this.props.lang}
                                        user={user}
                                        seller={seller}
                                        orderView={statements.order || ''}
                                        isLoading={this.props.isPaymentsLoading}
                                        isFinanceLoading={
                                            this.props.isFinanceLoading
                                        }
                                        getFinanceViewData={
                                            this.getFinanceViewData
                                        }
                                        financeData={statements.finance || ''}
                                        exportStatements={this.exportStatements}
                                        browser={this.props.browser}
                                        docType={docType}
                                        scrollPage={this.state.scrollPage}
                                        scroll
                                        loadFunc={this.loadFunc}
                                        showNoLoading={showNoLoading}
                                    />
                                ) : (
                                    <div>
                                        <EmptyResults
                                            heading={I18n.getText(
                                                'transfers.nothing-to-show',
                                            )}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                    <div className={styles.statementCtr}>
                        <div>
                            <div className={styles.topWrapper}>
                                <ToggleButton
                                    toggleBtn={this.toggleStatements}
                                    toggleItems={[
                                        I18n.getText('statement.invoice'),
                                        I18n.getText('statement.credit-notes'),
                                        I18n.getText('statement.payments'),
                                    ]}
                                    selected={this.state.statementsType}
                                />
                                {(statements &&
                                    (statements.invoices &&
                                        statements.invoices.invoices &&
                                        this.state.statementsType === 1)) ||
                                (statements.payments &&
                                    statements.payments.statements &&
                                    this.state.statementsType === 3) ||
                                (statements.creditNotes &&
                                    statements.creditNotes.credits &&
                                    this.state.statementsType === 2) ? (
                                    <div className={styles.datePicker}>
                                        <div className={styles.label}>
                                            {I18n.getText(
                                                'statement.date-range',
                                                {},
                                                'Date range',
                                            )}
                                        </div>
                                        {I18n.getComponent(
                                            formattedValue => (
                                                <DatePicker
                                                    withPortal={
                                                        !this.props.browser
                                                            .greaterThan.tablet
                                                    }
                                                    placeholder={'YYYY-MM-DD'}
                                                    initialDate={
                                                        this.state.fromDate
                                                    }
                                                    selectedDate={
                                                        this.selectedFromDate
                                                    }
                                                    clearDate={
                                                        !this.state.fromDate
                                                    }
                                                    isOutsideRange={day =>
                                                        day.isBefore(
                                                            minimumPaidAtDate,
                                                        ) ||
                                                        day.isAfter(maxDate) ||
                                                        day.isAfter(maximumDate)
                                                    }
                                                />
                                            ),
                                            'statement.start-date',
                                        )}
                                        <div className={styles.label}>
                                            {I18n.getText(
                                                'statement.date-to',
                                                {},
                                                'to',
                                            )}
                                        </div>
                                        {I18n.getComponent(
                                            formattedValue => (
                                                <DatePicker
                                                    placeholder={'YYYY-MM-DD'}
                                                    withPortal={
                                                        !this.props.browser
                                                            .greaterThan.tablet
                                                    }
                                                    selectedDate={
                                                        this.selectedToDate
                                                    }
                                                    initialDate={
                                                        this.state.toDate
                                                    }
                                                    clearDate={
                                                        !this.state.toDate
                                                    }
                                                    isOutsideRange={day =>
                                                        day.isBefore(
                                                            minimumDate,
                                                        ) ||
                                                        day.isAfter(maxDate)
                                                    }
                                                />
                                            ),
                                            'statement.end-date',
                                        )}
                                        <Button
                                            variant="transparent"
                                            className={styles.btn}
                                            onClick={() =>
                                                this.rangeSubmit(
                                                    this.state.statementsType,
                                                )
                                            }
                                            disabled={
                                                !this.state.fromDate ||
                                                !this.state.toDate
                                            }
                                        >
                                            {I18n.getText(
                                                'statement.go-btn',
                                                {},
                                                'Go',
                                            )}
                                        </Button>
                                        <Button
                                            variant="transparent"
                                            onClick={this.clearDate}
                                            className={styles.clear}
                                            className={styles.btn}
                                            disabled={
                                                !this.state.fromDate &&
                                                !this.state.toDate
                                            }
                                        >
                                            {I18n.getText(
                                                'statement.clear',
                                                {},
                                                'Clear',
                                            )}
                                        </Button>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                            {this.state.search && onSearch ? (
                                <SearchString
                                    search={this.state.search}
                                    clearSearch={() => onSearch('')}
                                />
                            ) : (
                                ''
                            )}
                            <div className={styles.tableWrapper}>
                                {this.props.isLoading ? (
                                    <div>
                                        <Loader />
                                    </div>
                                ) : (
                                    <div>
                                        {statements &&
                                        statements.invoices &&
                                        statements.invoices.invoices &&
                                        this.state.statementsType === 1 ? (
                                            <div>
                                                <ToggleButton
                                                    toggleBtn={
                                                        this.toggleInvoice
                                                    }
                                                    tab
                                                    toggleItems={[
                                                        I18n.getText(
                                                            'statement.customer',
                                                        ),
                                                        I18n.getText(
                                                            'statement.noon',
                                                        ),
                                                    ]}
                                                    selected={
                                                        this.state.invoiceType
                                                    }
                                                />
                                                <div
                                                    className={
                                                        styles.contentOverlay
                                                    }
                                                >
                                                    {this.props
                                                        .isNoonInvoiceLoading ? (
                                                        <Loader />
                                                    ) : (
                                                        <div>
                                                            {statements.invoices
                                                                .invoices &&
                                                            statements.invoices
                                                                .invoices[0] &&
                                                            !_.isEmpty(
                                                                statements
                                                                    .invoices
                                                                    .invoices[0],
                                                            ) ? (
                                                                <div>
                                                                    {statements &&
                                                                    statements.invoices &&
                                                                    statements
                                                                        .invoices
                                                                        .invoices &&
                                                                    statements
                                                                        .invoices
                                                                        .invoices
                                                                        .length ? (
                                                                        <InvoiceList
                                                                            data={
                                                                                statements
                                                                                    .invoices
                                                                                    .invoices
                                                                            }
                                                                            currencyCode={
                                                                                currencyCode
                                                                            }
                                                                            exportInvoice={
                                                                                this
                                                                                    .exportInvoice
                                                                            }
                                                                            browser={
                                                                                this
                                                                                    .props
                                                                                    .browser
                                                                            }
                                                                            searchString={
                                                                                this
                                                                                    .state
                                                                                    .search
                                                                            }
                                                                            isExportLoading={
                                                                                this
                                                                                    .props
                                                                                    .isExportLoading
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <EmptyResults type="invoices" />
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <EmptyResults type="invoices" />
                                                            )}
                                                            {statements &&
                                                            statements.invoices &&
                                                            statements.invoices
                                                                .no_of_pages &&
                                                            statements.invoices
                                                                .no_of_pages >
                                                                1 ? (
                                                                <div>
                                                                    <Pagination
                                                                        pageCount={Number(
                                                                            statements
                                                                                .invoices
                                                                                .no_of_pages,
                                                                        )}
                                                                        currentPage={
                                                                            this
                                                                                .state
                                                                                .currentPage
                                                                        }
                                                                        onPageChange={
                                                                            this
                                                                                .onPageChange
                                                                        }
                                                                    />
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                )}
                                {this.props.isCreditNotesLoading ? (
                                    <Loader />
                                ) : (
                                    <div>
                                        {statements &&
                                        statements.creditNotes &&
                                        statements.creditNotes.credits &&
                                        this.state.statementsType === 2 ? (
                                            <div>
                                                {statements &&
                                                statements.creditNotes &&
                                                statements.creditNotes
                                                    .credits &&
                                                statements.creditNotes.credits
                                                    .length ? (
                                                    <CreditNoteList
                                                        data={
                                                            statements
                                                                .creditNotes
                                                                .credits
                                                        }
                                                        currencyCode={
                                                            currencyCode
                                                        }
                                                        history={
                                                            this.props.history
                                                        }
                                                        lang={this.props.lang}
                                                        searchString={
                                                            this.state.search
                                                        }
                                                        browser={
                                                            this.props.browser
                                                        }
                                                        exportCreditNote={
                                                            this
                                                                .exportCreditNote
                                                        }
                                                    />
                                                ) : (
                                                    <EmptyResults type="creditNotes" />
                                                )}
                                                {statements &&
                                                statements.creditNotes &&
                                                statements.creditNotes
                                                    .no_of_pages &&
                                                statements.creditNotes
                                                    .no_of_pages > 1 ? (
                                                    <div>
                                                        <Pagination
                                                            pageCount={Number(
                                                                statements
                                                                    .creditNotes
                                                                    .no_of_pages,
                                                            )}
                                                            currentPage={
                                                                this.state
                                                                    .currentPage
                                                            }
                                                            onPageChange={
                                                                this
                                                                    .onPageChange
                                                            }
                                                        />
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                        {this.props.isPaymentsLoading ? (
                                            <div>
                                                <Loader />
                                            </div>
                                        ) : statements &&
                                          statements.payments &&
                                          statements.payments.statements &&
                                          this.state.statementsType === 3 ? (
                                            <div>
                                                {statements &&
                                                statements.payments &&
                                                !_.isEmpty(
                                                    statements.payments,
                                                ) ? (
                                                    <PaymentList
                                                        paymentsData={
                                                            statements.payments
                                                        }
                                                        currencyCode={
                                                            currencyCode
                                                        }
                                                        history={
                                                            this.props.history
                                                        }
                                                        lang={this.props.lang}
                                                        searchString={
                                                            this.state.search
                                                        }
                                                        browser={
                                                            this.props.browser
                                                        }
                                                    />
                                                ) : (
                                                    <EmptyResults
                                                        type="payments"
                                                        handleBtnClick={
                                                            this.state
                                                                .fromDate ||
                                                            this.state.toDate ||
                                                            this.state.search
                                                                ? this
                                                                      .clearPaidAt
                                                                : ''
                                                        }
                                                    />
                                                )}
                                                {statements &&
                                                statements.payments &&
                                                statements.payments
                                                    .no_of_pages &&
                                                statements.payments
                                                    .no_of_pages > 1 ? (
                                                    <div>
                                                        <Pagination
                                                            pageCount={Number(
                                                                statements
                                                                    .payments
                                                                    .no_of_pages,
                                                            )}
                                                            currentPage={
                                                                this.state
                                                                    .currentPage
                                                            }
                                                            onPageChange={
                                                                this
                                                                    .onPageChange
                                                            }
                                                        />
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </Layout>
        );
    }
}
const mapStateToProps = state => {
    return {
        sessionIsLoading: state.session.isLoading,
        session: state.session,
        lang: state.locale.lang,
        user: state.session.user,
        seller: state.session.seller,
        orders: state.orders,
        statements: state.statements,
        isLoading: state.statements.isLoading,
        isCreditNotesLoading: state.statements.isCreditNotesLoading,
        isPaymentsLoading: state.statements.isPaymentsLoading,
        isFinanceLoading: state.statements.isFinanceLoading,
        isExportLoading: state.statements.isExportLoading,
        isNoonInvoiceLoading: state.statements.isNoonInvoiceLoading,
        browser: state.browser,
    };
};

export default connect(mapStateToProps)(Statements);



// WEBPACK FOOTER //
// ./src/containers/statements/Statements.js